abstract class ImageAsset {
  image = new Image();
  protected async loadImage(src: string) {
    return new Promise((resolve, reject) => {
      this.image.onload = resolve;
      this.image.onerror = reject;
      this.image.src = src;
    });
  }
}

class DynamicImageAsset extends ImageAsset {
  constructor(private filename: string) {
    super();
  }

  async load(src: string) {
    return this.loadImage(src + this.filename);
  }
}

class StaticImageAsset extends ImageAsset {
  constructor(src: string) {
    super();
    this.loadImage(src);
  }
}

export type ImageCollection<T> = {
  name: T;
  path: string;
  dynamic?: boolean;
}[];

export default class ImageProvider<T> {
  private images = new Map<T, ImageAsset>();

  constructor(private basePath: string, imageCollection: ImageCollection<T>) {
    for (const image of imageCollection) {
      this.images.set(
        image.name,
        image.dynamic ? new DynamicImageAsset(image.path) : new StaticImageAsset(basePath + image.path)
      );
    }
  }

  async preloadImages(dynamicPath?: string): Promise<void> {
    try {
      for (const [_, image] of this.images) {
        if (image instanceof DynamicImageAsset) {
          await image.load(this.basePath + dynamicPath + '/');
        }
      }
    } catch (e) {
      console.error('Error preloading images', e);
    }
  }

  get(key: T): HTMLImageElement {
    const res = this.images.get(key);
    if (!res) throw new Error(`No "${key}" image was found`);
    return res.image;
  }
}
